"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SalesForceInputConst = /** @class */ (function () {
    function SalesForceInputConst() {
    }
    Object.defineProperty(SalesForceInputConst, "UPGRADE_DISPLAY_TEXT_ENTRY", {
        get: function () {
            return [
                { displayText: 'Entry to Standard' },
                { displayText: 'Entry to Pro' }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceInputConst, "UPGRADE_DISPLAY_TEXT_BASIC", {
        get: function () {
            return [
                { displayText: 'Basic to Medium' },
                { displayText: 'Basic to Standard' },
                { displayText: 'Basic to Pro' }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceInputConst, "UPGRADE_DISPLAY_TEXT_MEDIUM", {
        get: function () {
            return [
                { displayText: 'Medium to Standard' },
                { displayText: 'Medium to Pro' }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceInputConst, "UPGRADE_DISPLAY_TEXT_STANDARD", {
        get: function () {
            return [
                { displayText: 'Standard to Pro' }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceInputConst, "UPGRADE_CAPACITY", {
        get: function () {
            return [
                { displayTextForUpgradeCapacity: '10名以下' },
                { displayTextForUpgradeCapacity: '11名以上' }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForceInputConst, "UPGRADE_DISPLAY_TEXT_SYSTEMS_ERROR", {
        get: function () {
            return [
                { displayText: 'システムエラーが発生しています。開発にご連絡ください。' }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return SalesForceInputConst;
}());
exports.default = SalesForceInputConst;
;



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/sales_force_input/sales_force_input_const.ts
// module id = XA2u
// module chunks = 1